// This is where we store a token from uaa related to an app itself
const AUTHENTICATION_APP_TOKEN = 'app_token'
const REFRESH_THRESHOLD_TIME = 12

module.exports = {
  AUTHENTICATION_APP_TOKEN,
  REFRESH_THRESHOLD_TIME,
}
